import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { CommonService } from './common.service';

@Injectable({
  providedIn: 'root'
})
export class InventoryService {
  readonly purchaseorderSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  constructor(
    public http: HttpClient,
    private commonService: CommonService
  ) {}

  // -----------------------------------
  // User & Config
  // -----------------------------------

  getUserData(obj: any) {
    const params = new HttpParams()
      .set('storecode', obj.storecode)
      .set('emailid', obj.emailid)
      .set('password', obj.password);
    return this.http.get(`${environment.baseUrl}Users/VerifyCredential`, { params })
      .pipe(catchError(this.commonService.handleError));
  }

  getPhaseConfig(storecode: string) {
    const params = new HttpParams().set('storecode', storecode);
    return this.http.get(`${environment.baseUrl}Storesetup/GetMofoterProConfig`, { params })
      .pipe(catchError(this.commonService.handleError));
  }

  getMofoterProConfig(storecode: string) {
    const params = new HttpParams().set('storecode', storecode);
    return this.http.get(`${environment.baseUrl}Storesetup/GetMofoterProConfig`, { params })
      .pipe(catchError(this.commonService.handleError));
  }

  // -----------------------------------
  // Products
  // -----------------------------------

  productData(obj: any) {
    const params = new HttpParams().set('productcode', '').set('storecode', obj.storecode);
    return this.http.get(`${environment.baseUrl}Product`, { params })
      .pipe(catchError(this.commonService.handleError));
  }

  producttoPurchase(obj: any) {
    const params = new HttpParams().set('storecode', obj.storecode);
    return this.http.get(`${environment.baseUrl}Purchaseorder/Producttopurchase`, { params })
      .pipe(catchError(this.commonService.handleError));
  }

  getProductData(obj: any) {
    const params = new HttpParams().set('storecode', obj.storecode);
    return this.http.get(`${environment.baseUrl}Product`, { params })
      .pipe(catchError(this.commonService.handleError));
  }

  getProductDataByOutlet(storecode: string, outletcode: string) {
    const params = new HttpParams()
      .set('storecode', storecode)
      .set('productcode', '')
      .set('outletcode', outletcode || '');
    return this.http.get(`${environment.baseUrl}Product`, { params })
      .pipe(catchError(this.commonService.handleError));
  }

  AddProductEdit(model: any) {
    return this.http.post(`${environment.baseUrl}Product`, model)
      .pipe(catchError(this.commonService.handleError));
  }

  UpdateProduct(model: any) {
    return this.http.put(`${environment.baseUrl}Product/UpdateProduct`, model)
      .pipe(catchError(this.commonService.handleError));
  }

  // -----------------------------------
  // Purchase Orders
  // -----------------------------------

  PurchaseOrder(model: any) {
    return this.http.post(`${environment.baseUrl}Purchaseorder`, model)
      .pipe(catchError(this.commonService.handleError));
  }

  PurchaseOrderEdit(model: any) {
    return this.http.put(`${environment.baseUrl}Purchaseorder`, model)
      .pipe(catchError(this.commonService.handleError));
  }

  ReceiveData(model: any) {
    return this.http.put(`${environment.baseUrl}Purchaseorder/UpdatePurchaseOrder`, model)
      .pipe(catchError(this.commonService.handleError));
  }

  postPhase2PurchaseOrder(payload: any) {
    return this.http.post(`${environment.baseUrl}Purchaseorder/Phase2`, payload)
      .pipe(catchError(this.commonService.handleError));
  }

  purchaseOrderList(obj: any, purchaseordernumber: string, outletcode: string) {
    const params = new HttpParams()
      .set('storecode', obj.storecode)
      .set('purchaseordernumber', purchaseordernumber)
      .set('outletcode', outletcode);
    return this.http.get(`${environment.baseUrl}purchaseorder`, { params })
      .pipe(catchError(this.commonService.handleError));
  }

  getInventoryCountData(obj: any, list: any) {
    const params = new HttpParams()
      .set('productcode', list.productcode)
      .set('storecode', obj.storecode);
    return this.http.get(`${environment.baseUrl}purchaseorder/InventoryCount`, { params })
      .pipe(catchError(this.commonService.handleError));
  }

  PurchaseOrderDelete(obj: any) {
    const params = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      body: {
        purchaseordernumber: obj.purchaseordernumber,
        punchedby: obj.punchedby
      }
    };
    return this.http.delete(`${environment.baseUrl}Purchaseorder`, params)
      .pipe(catchError(this.commonService.handleError));
  }

  // ✅ Updated: get purchase order from new GetPhase2 API
  getPurchaseOrderById(storecode: string, purchaseordernumber: string, outletcode: string) {
    const params = new HttpParams()
      .set('storecode', storecode)
      .set('purchaseordernumber', purchaseordernumber)
      .set('outletcode', outletcode);
    return this.http.get(`${environment.baseUrl}Purchaseorder/GetPhase2`, { params })
      .pipe(catchError(this.commonService.handleError));
  }

  // ✅ Updated: submit return order to new Return API
  submitReturnOrder(model: any) {
    return this.http.post(`${environment.baseUrl}Purchaseorder/Return`, model)
      .pipe(catchError(this.commonService.handleError));
  }

  // -----------------------------------
  // Expenses
  // -----------------------------------

  Expense(model: any) {
    return this.http.post(`${environment.baseUrl}Purchaseorder/Expense`, model)
      .pipe(catchError(this.commonService.handleError));
  }

  getExpense(obj: any) {
    const params = new HttpParams().set('storecode', obj.storecode);
    return this.http.get(`${environment.baseUrl}Purchaseorder/getExpenses`, { params })
      .pipe(catchError(this.commonService.handleError));
  }

  getExpenseFromTo(obj: any, fromdate: string, todate: string) {
    const params = new HttpParams()
      .set('storecode', obj.storecode)
      .set('fromdate', fromdate)
      .set('todate', todate);
    return this.http.get(`${environment.baseUrl}Purchaseorder/getExpenses`, { params })
      .pipe(catchError(this.commonService.handleError));
  }

  ExpensePUT(model: any) {
    return this.http.put(`${environment.baseUrl}Purchaseorder/UpdateExpense`, model)
      .pipe(catchError(this.commonService.handleError));
  }

  ExpenseDelete(obj: any) {
    const params = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      body: {
        expensecode: obj.expensecode,
        id: obj.id
      }
    };
    return this.http.delete(`${environment.baseUrl}Purchaseorder/DeleteExpense`, params)
      .pipe(catchError(this.commonService.handleError));
  }

  // -----------------------------------
  // Other master data
  // -----------------------------------

  getOutletData(obj: any) {
    const params = new HttpParams().set('storecode', obj.storecode);
    return this.http.get(`${environment.baseUrl}Outlet`, { params })
      .pipe(catchError(this.commonService.handleError));
  }

  getSupplierData(obj: any) {
    const params = new HttpParams().set('storecode', obj.storecode);
    return this.http.get(`${environment.baseUrl}Supplier`, { params })
      .pipe(catchError(this.commonService.handleError));
  }
}
